/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { utils } from '@broadleaf/admin-components'; // import our axios instance
import { isEmpty } from 'lodash';

utils.axios.interceptors.request.use(function (config) {
  if (config.url.startsWith('/auth/user-operations')) {
    const applicationId = getApplicationId(config);
    return {
      ...config,
      params: { ...config.params, applicationId }
    };
  }
  return config;
}, null);

function getApplicationId(config) {
  return getApplicationIdFromScopesParam(config) || getApplicationIdFromCache();
}

function getApplicationIdFromScopesParam(config) {
  const scopes = config.params.scope || [];
  if (isEmpty(scopes)) {
    return null;
  }
  // get the last item in the scopes array. This may be the applicationId
  const lastScope = scopes[scopes.length - 1];
  if (!lastScope.startsWith('APPID_')) {
    return null;
  }
  // If the last scope is the applicationId, remove it from the scopes array
  // and return the value
  scopes.pop();
  config.params.scope = scopes;
  if (lastScope === 'APPID_NONE') {
    // We're at the tenant level, so we want to use the 'AURORA' applicationId
    return 'AURORA';
  } else {
    return lastScope.substring(6);
  }
}

function getApplicationIdFromCache() {
  // NOTE: We cannot assume that the tenant cache has been updated
  // with the correct applicationId when the user-operations request is made.
  // This is a fallback to old behavior just in case, but is not guaranteed to
  // return the most up-to-date value.
  const serializedTenantCache =
    sessionStorage.getItem('tenantCache') ||
    sessionStorage.getItem('tenantCache');
  const tenantCache = new Map(JSON.parse(serializedTenantCache) || []);
  const cacheKey = `tenant_resolver_${window.location.hostname}`;
  const tenantStateRecord = tenantCache.get(cacheKey);
  const tenantState = tenantStateRecord.value;
  return tenantState.applicationId || 'AURORA';
}
